import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start mb-6" }
const _hoisted_2 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 flex-shrink-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h4", { class: "fw-bold mb-2" }, "What is AI 24/7?"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted mb-0 fs-6" }, " AI 24/7 is your all-in-one business CRM and marketing hub — powered by AI that works around the clock so you never miss a lead. ")
], -1)
const _hoisted_4 = { class: "row g-5 mb-6" }
const _hoisted_5 = { class: "card h-100 border border-gray-300 border-dashed" }
const _hoisted_6 = { class: "card-body d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-start mb-3" }
const _hoisted_8 = { class: "svg-icon svg-icon-2 svg-icon-primary me-3 flex-shrink-0 mt-1" }
const _hoisted_9 = { class: "fw-bold mb-2" }
const _hoisted_10 = { class: "text-muted fs-7 mb-0" }
const _hoisted_11 = { class: "mt-auto pt-2" }
const _hoisted_12 = { class: "alert alert-light-primary d-flex align-items-center fs-7 mb-0" }
const _hoisted_13 = { class: "svg-icon svg-icon-2 svg-icon-primary me-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Not activated yet? Go to the ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" tab to create your AI 24/7 location. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Address-card.svg" })
      ]),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.features, (item) => {
        return (_openBlock(), _createBlock("div", {
          key: item.title,
          class: "col-md-6"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, {
                    src: item.icon
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", null, [
                  _createVNode("h5", _hoisted_9, _toDisplayString(item.title), 1),
                  _createVNode("p", _hoisted_10, _toDisplayString(item.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light-primary",
                  onClick: ($event: any) => (_ctx.$emit('navigate', item.tab))
                }, _toDisplayString(item.cta), 9, ["onClick"])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("span", _hoisted_13, [
        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
      ]),
      _createVNode("span", null, [
        _hoisted_14,
        _createVNode("button", {
          type: "button",
          class: "btn btn-link btn-sm p-0 align-baseline fw-bold",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'portal')))
        }, " Account "),
        _hoisted_15
      ])
    ])
  ]))
}